// extracted by mini-css-extract-plugin
export default {"container":"Chat_container__LPh+l","messages":"Chat_messages__utHg0","Header":"Chat_Header__c8c8K"};